export default __webpack_public_path__ + "static/media/10.88007c1f.jpg";